import React from "react"
import type { FC } from "react"

import { HStack } from "@/nzds/layout"
import { camelCase } from "lodash-es"

import { Divider, Stack, Typography } from "@mui/material"

import type { SectionHeaderProps } from "./section-header.types"

export const SectionHeader: FC<SectionHeaderProps> = ({
  title,
  divider = true,
  actions,
  sx,
}) => (
  <Stack
    sx={[
      {
        gap: 1.5,
      },
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <HStack sx={{ alignItems: "flex-start", gap: 2 }}>
      <Typography id={camelCase(title)} sx={{ flex: 1 }} variant="h3">
        {title}
      </Typography>
      {actions ?? null}
    </HStack>
    {divider ? <Divider /> : null}
  </Stack>
)
